// extracted by mini-css-extract-plugin
module.exports = {"bonusesContainer":"styles_bonusesContainer__8nAel","emptyBonuses":"styles_emptyBonuses__bJKRV"};